module.exports = __webpack_public_path__ + "img/1icon@2x.d751681b.png";